// extracted by mini-css-extract-plugin
var _1 = "WeekDays-moduleWeekDays__b0_jo";
var _2 = "WeekDays-moduleitem__Y5Oq_ WeekDay-moduleWeekDay__mvlIm Day-moduleDay__tTwxX";
export { _1 as "WeekDays", _2 as "item" }
